import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function ModalCloseIcon({ color = "offWhite" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M20 35C28.2843 35 35 28.2843 35 20C35 11.7157 28.2843 5 20 5C11.7157 5 5 11.7157 5 20C5 28.2843 11.7157 35 20 35Z"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 20L15 15M20 20L25 25M20 20L25 15M20 20L15 25"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke={COLORS[color]}
      />
    </svg>
  );
}
